import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute, } from '@angular/router';
import { select, Store, } from '@ngrx/store';
import { SearchResultHelper } from 'core/utils/search-result-helper';
import { Subscription } from 'rxjs';
import { ShowcasesEntity, ShowcasesTypes, } from 'search/full-card/models/showcases';
import { SearchResult } from 'search/models/search-results';
import { Entity, FormatGroup, isFormatGroup, } from '../../../../entity/models/entity';
import { selectEntity } from '../../../../entity/reducers/full-entity.reducer';
import { ShowcasesState } from '../../reducers/showcases.reducer';

@Component({
  selector: 'app-card-body',
  templateUrl: './card-body.component.html',
  styleUrls: ['./card-body.component.scss'],
})
export class CardBodyComponent implements OnInit, OnDestroy {
  public data: SearchResult | Entity;
  public entity: ShowcasesEntity;
  public showcaseType: string;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private store: Store<ShowcasesState>,
    public searchResultHelper: SearchResultHelper,
    private cdRef: ChangeDetectorRef,
    public route: ActivatedRoute
  ) {}

  @HostBinding('class.gradient') public get isGradientVisible() {
    return !this.showcaseType || this.showcaseType === ShowcasesTypes.NYT;
  }

  public ngOnInit() {
    this.subscriptions.add(this.route.queryParams.subscribe((params) => {
      this.showcaseType = params.showcase;
    }));

    this.subscriptions.add(this.store.pipe(select(selectEntity)).subscribe((entity: Entity | FormatGroup) => {
      if (entity) {
        this.entity = {
          id: entity.id,
          entityType: entity.entityType,
          title: isFormatGroup(entity) ? this.searchResultHelper.extractTitle(entity) : (entity as Entity).label,
          isbn: isFormatGroup(entity) ? entity.identifiers?.isbn : null,
          agentId: isFormatGroup(entity) ? entity.primaryAgent?.id : null,
        };
        this.cdRef.markForCheck();
      }
    }));
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
